import billerPendingApprovalsActionsType from "../actions/types/billerPendingApproval.action.type";
import store from "../store/index";
import axios from "axios";
import {
  getErrorMessageFromException,
  getExceptionMessage,
  API_BASE_URL,
} from "../utils/helper";

export const billerPendingApprovalService = {
  getPendingBillerApprovals,
  getBillerChangesDetails,
  declineBillerApprovalData,
  createBillerApprovalData,
  updateBillerApprovalData,
};
function getPendingBillerApprovals(searchValues, setLoading) {
  return (dispatch) => {
    const userFiNumber = store.getState()?.loginUserReducer?.user?.fiNumber;
    const token = store.getState()?.loginUserReducer.token;
    axios
      .post(
        API_BASE_URL() + "/biller-pending-approvals/list",
        {
          ...searchValues,
          loggedInUserFiNumber: userFiNumber,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        const parsedData = JSON.parse(JSON.stringify(res)).data;
        dispatch({data: parsedData.data,
                  totalCount: parsedData.count,
                  searchValues: searchValues, // Saving searchValues - this is needed to remember pagination options
                  type: billerPendingApprovalsActionsType.GET_PENDING_BILLER_APPROVAL_SUCCESS
        });
        if (setLoading)
          setLoading(false);
      })
      .catch((error) => {
        const parsedError = getExceptionMessage(error);
        dispatch({ error: parsedError,
                   type: billerPendingApprovalsActionsType.GET_PENDING_BILLER_APPROVAL_FAILURE
        });
        if (setLoading)
          setLoading(false);
      });
  };
}

function getBillerChangesDetails(
  data,
  setLoading,
  setShowExceptionMessage  
) {
  return (dispatch) => {
    const userFiNumber = store.getState()?.loginUserReducer?.user?.fiNumber;
    const token = store.getState()?.loginUserReducer.token;
    axios
      .post(
        API_BASE_URL() + "/biller-pending-approvals/biller-changes-details",
        {
          ...data,
          loggedInUserFiNumber: userFiNumber,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        const parsedData = JSON.parse(JSON.stringify(res)).data;
        dispatch({data: parsedData,
                  type: billerPendingApprovalsActionsType.GET_BILLER_USER_APPROVAL_SUCCESS
        });
        if (setLoading)
          setLoading(false);
      })
      .catch((error) => {
        const parsedError = getExceptionMessage(error);
        dispatch({error: parsedError,
                  type: billerPendingApprovalsActionsType.GET_BILLER_USER_APPROVAL_FAILURE
        });
        if (setShowExceptionMessage) {
          setShowExceptionMessage(true);
        }
        if (setLoading)
          setLoading(false);
      });
  };
}

function declineBillerApprovalData(data, props) {
  return (dispatch) => {
    const { hasLastRecord, setLastRecordDisable } = props;
    const token = store.getState()?.loginUserReducer.token;
    axios
      .post(
        API_BASE_URL() + "/biller-pending-approvals/decline-biller",
        {
          ...data,
          hasLastRecord,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        const parsedData = JSON.parse(JSON.stringify(res)).data;
        dispatch({data: parsedData,
                  nextTransactionId: props?.nextTransactionId,
                  queueDataList: props?.queueDataList,
                  type: billerPendingApprovalsActionsType.DECLINE_BILLER_USER_APPROVAL_SUCCESS
        });
        if (props?.setShowMessage) {
          props?.setShowMessage(true);
        }
        if (hasLastRecord && setLastRecordDisable) {
          setLastRecordDisable(hasLastRecord);
        }
        props.setLoading(false);
      })
      .catch((error) => {
        const parsedError = getExceptionMessage(error);
        dispatch({error: parsedError,
                  type: billerPendingApprovalsActionsType.DECLINE_BILLER_USER_APPROVAL_FAILURE
        });
        if (props?.setShowMessage) {
          props?.setShowMessage(false);
        }
        props.setLoading(false);
      });
  };
}

function updateBillerApprovalData(data, props) {
  return (dispatch) => {
    const { hasLastRecord, setLastRecordDisable } = props;
    const token = store.getState()?.loginUserReducer.token;
    axios
      .post(
        API_BASE_URL() + "/biller-pending-approvals/approve-pending-biller",
        {
          ...data,
          hasLastRecord,
          portalType: localStorage.getItem("type")
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        const parsedData = JSON.parse(JSON.stringify(res)).data;
        dispatch({data: parsedData,
                  nextTransactionId: props?.nextTransactionId,
                  queueDataList: props?.queueDataList,
                  type: billerPendingApprovalsActionsType.UPDATE_BILLER_USER_APPROVAL_SUCCESS
        });
        if (props?.setShowMessage) {
          props?.setShowMessage(true);
        }
        if (hasLastRecord && setLastRecordDisable) {
          setLastRecordDisable(hasLastRecord);
        }
        props.setLoading(false);
      })
      .catch((error) => {
        const parsedError = getErrorMessageFromException(error, props.t) || JSON.parse(JSON.stringify(error))?.message;
        dispatch({error: parsedError,
                  type: billerPendingApprovalsActionsType.UPDATE_BILLER_USER_APPROVAL_FAILURE
        });
        if (props?.setShowMessage) {
          props?.setShowMessage(false);
        }
        props.setLoading(false);
      });
  };
}

function createBillerApprovalData(data, props) {
  return (dispatch) => {
    const { hasLastRecord, setLastRecordDisable } = props;
    const token = store.getState()?.loginUserReducer.token;
    axios
      .post(
        API_BASE_URL() + "/biller-pending-approvals/approve-pending-biller",
        {
          ...data,
          hasLastRecord,
          portalType: localStorage.getItem("type")
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        const parsedData = JSON.parse(JSON.stringify(res)).data;
        dispatch({data: parsedData,
                  nextTransactionId: props?.nextTransactionId,
                  queueDataList: props?.queueDataList,
                  type: billerPendingApprovalsActionsType.CREATE_BILLER_USER_APPROVAL_SUCCESS
        });
        if (props?.setShowMessage) {
          props?.setShowMessage(true);
        }
        if (hasLastRecord && setLastRecordDisable) {
          setLastRecordDisable(hasLastRecord);
        }
        props.setLoading(false);
      })
      .catch((error) => {
        const parsedError = getExceptionMessage(error);
        dispatch({error: parsedError,
                  type: billerPendingApprovalsActionsType.CREATE_BILLER_USER_APPROVAL_FAILURE
        });
        if (props?.setShowMessage) {
          props?.setShowMessage(false);
        }
        props.setLoading(false);
      });
  };
}
